import React from "react";
import { Button } from "@mui/material";

export default function Tab(props) {
  return (
    <>
      <Button
        style={{
          paddingTop: 5,
          paddingBottom: 5,

          fontSize: "13px",
          borderBottom:
            "solid 1px " + (props.selected ? "#ff5722" : "transparent"),
          borderRadius: 0,
          textWrap: "nowrap",

          minWidth: "unset",
        }}
      >
        <span style={{ color: "silver" }}>
          {props.keyName}
          {"-"}
        </span>
        {props.name}
      </Button>
    </>
  );
}
